import { Loader } from '@statsbomb/kitbag-components';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { useEffect } from 'react';
import { messageOffsetAlignmentVerificationAtom } from '../../atoms/messages';
import { videosRequiringAlignmentVerificationLoadingAtom } from '../../atoms/offsetAlignment';
import { AlignmentVerification } from '../../components/AlignmentVerification/AlignmentVerification';
import useVideosRequiringOffsetAlignmentVerification from '../../hooks/offsetAlignment';

export function AlignmentVerificationStream() {
  const setMessage = useSetAtom(messageOffsetAlignmentVerificationAtom);

  const {
    clearVideosRequiringOffsetVerification,
    requestVideosRequiringAlignmentVerification,
  } = useVideosRequiringOffsetAlignmentVerification();
  const videosRequiringAlignmentVerificationLoading = useAtomValue(
    videosRequiringAlignmentVerificationLoadingAtom,
  );

  useEffect(() => {
    setMessage(null);
    requestVideosRequiringAlignmentVerification();
    return () => {
      clearVideosRequiringOffsetVerification();
    };
  }, []);

  return videosRequiringAlignmentVerificationLoading ? (
    <Loader colour="primary" />
  ) : (
    <AlignmentVerification />
  );
}

export default { AlignmentVerificationStream };
